import Button from "./Button";
import aboutImg from "../images/aboutImg.jpg";
export default function ChallengeFriend() {
  return (
    <section className="py-16 px-6 mt-14" id="join-community">
      <div className="grid lg:grid-cols-3 lg:gap-4 gap-6 lg:justify-between items-center justify-center text-center lg:text-start mx-auto w-3/4">
        <div>
          <h2 className="text-lg md:text-3xl font-black text-medium-black mb-4">
            Challenge your friend
          </h2>
          <p className="text-md text-light-grey font-normal mb-6 xl:text-xl xxl:text-2xl ">
            Stop doing your sport alone and challenge your friend who will be
            the Best
          </p>
          <Button color="light-purple">Join Community</Button>
        </div>

        <div className="w-full ">
          <img src={aboutImg} alt="about" />
        </div>

        <div className="flex flex-col gap-12 items-center lg:items-left">
          <div>
            <h3 className="font-bold text-medium-black lg:text-2xl mb-2">
              Get Inspired
            </h3>
            <p className="lg:text-xl text-light-grey">
              Dive into a world where sweat meets determination, and every
              workout is a step closer to your best self.
            </p>
          </div>
          <div>
            <h3 className="font-bold text-medium-black lg:text-2xl mb-2">
              Others Inspired
            </h3>
            <p className=" lg:text-xl text-light-grey">
              Dive into a world where sweat meets determination, and every
              workout is a step closer to your best self.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
